// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_p9-8";
export var editMode = "_p9-3";
export var headerRow = "_p9-a";
export var headerTitle = "_p9-b";
export var product = "_p9-1";
export var productDetails = "_p9-5";
export var productDivider = "_p9-7";
export var productImage = "_p9-2";
export var productInfo = "_p9-4";
export var productTitle = "_p9-6";
export var strikethrough = "_p9-9";
export var upsellProductsCard = "_p9-0";